const BASE_URL = `${process.env.REACT_APP_API_BOOKINGS_BASE_URL}/Bookings`;

export const getBookingsForParkingArea = async (token, parkingAreaExtId, {
    page = 1,
    pageSize = 10,
    search = '',
    includeExpired = false
} = {}, { signal } = {}) => {
    const params = new URLSearchParams({ page, pageSize, includeExpired });
    if (search) params.set('search', search);

    const response = await fetch(`${BASE_URL}/parking-area/${parkingAreaExtId}?${params}`, {
        method: 'GET',
        headers: {
            'content-type': 'application/json',
            'authorization': `Bearer ${token}`
        },
        signal,
    });

    if (response.status === 200) {
        const responseBody = await response.text();

        if (!responseBody) {
            return {};
        } else {
            return JSON.parse(responseBody);
        }
    }

    throw response;
}
